var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group:-2-objects"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M4.167,0l21.667,0c2.301,0 4.167,1.865 4.167,4.167l0,21.667c0,2.301 -1.865,4.167 -4.167,4.167l-21.667,0c-2.301,0 -4.167,-1.865 -4.167,-4.167l0,-21.667c0,-2.301 1.865,-4.167 4.167,-4.167Z",
    style: {
      fill: "#4e87ae",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group:-2-objects1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path1",
    d: "M24.582,9.842c0.418,1.671 0.418,5.158 0.418,5.158c0,0 0,3.487 -0.418,5.158c-0.23,0.922 -0.908,1.648 -1.768,1.894c-1.56,0.448 -7.814,0.448 -7.814,0.448c0,0 -6.254,0 -7.814,-0.448c-0.86,-0.246 -1.538,-0.972 -1.768,-1.894c-0.418,-1.671 -0.418,-5.158 -0.418,-5.158c0,0 0,-3.487 0.418,-5.158c0.23,-0.922 0.908,-1.648 1.768,-1.894c1.56,-0.448 7.814,-0.448 7.814,-0.448c0,0 6.254,0 7.814,0.448c0.861,0.246 1.538,0.973 1.768,1.894Zm-11.627,8.323l5.227,-3.165l-5.227,-3.166l0,6.331Z",
    style: {
      fill: "#fff"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon_youtube.c962d66cc9ddf0a93e692bf7503ff25b.svg";
export { ForwardRef as ReactComponent };